import { render, staticRenderFns } from "./WovenLotReport.vue?vue&type=template&id=52f11e81&scoped=true"
import script from "./WovenLotReport.vue?vue&type=script&lang=js"
export * from "./WovenLotReport.vue?vue&type=script&lang=js"
import style0 from "./WovenLotReport.vue?vue&type=style&index=0&id=52f11e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f11e81",
  null
  
)

export default component.exports